module.exports = __webpack_public_path__ + "e-learning-app/static/img/head4.b68a621.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-area/img/ne/head4.png
// module id = k6mh
// module chunks = 1